<header [hidden]="!showHeader" floScrollDetection (scroll)="scrollEvent()" (mouseleave)="hideDropdowns()"
        [class.nav-up]="didScroll">
    <div class="nav-container container">
        <div class="wide-nav-bar row">
            <div class="nav-bar col-md-9">

                <a [href]="siteSettings?.coreSiteUrl">
                    <img class="logo" routerLink routerLinkActive="active" *ngIf="siteSettings?.site?.name"
                         [attr.title]="siteSettings.site.name" [alt]="siteSettings.site.name"
                         src="../../assets/images/FloArena-Alt.svg">
                </a>

                <nav>
                    <ul>
                        <li *ngFor="let nav of customNav;">
                            <a class="primary-color-text-active" [href]="nav.link" routerLinkActive="active">
                                {{ nav.name }}</a>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="utility-bar col-md-3">
                <ul class="navbar-nav">
                    <li class="nav-icon primary-color-bg-hover">
                        <a class="search-button apply-bg-hover" [href]="sportConfigHeader?.searchUrl">
                            <span class="fas fa-search"></span>
                        </a>
                    </li>

                    <li class="dropdown nav-icon primary-color-bg-hover"
                        (click)="isShareDropdownShown()"
                        [class.active]="showShareIcons">
                        <a class="dropdown-toggle apply-bg-hover">
                            <span class="fas fa-share-alt"></span>
                        </a>
                        <ul class="dropdown-menu" [class.show-dropdown]="showShareIcons">
                            <li>
                                <a target="_blank" *ngIf="siteSettings?.facebookPageUrl"
                                   href="{{ siteSettings?.facebookPageUrl }}">
                                    <span class="fab fa-facebook-f"></span>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" *ngIf="siteSettings?.twitterPageUrl"
                                   href="{{ siteSettings?.twitterPageUrl }}">
                                    <span class="fab fa-twitter"></span>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" *ngIf="siteSettings?.instagramPageUrl"
                                   href="{{ siteSettings?.instagramPageUrl }}">
                                    <span class="fab fa-instagram"></span>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" *ngIf="siteSettings?.youtubePageUrl"
                                   href="{{ siteSettings?.youtubePageUrl }}">
                                    <span class="fab fa-youtube"></span>
                                </a>
                            </li>
                        </ul>
                    </li>

                    <li *ngIf="!authService.isLoggedIn()" class="primary-color-bg-hover">
                        <a class="apply-bg-hover" routerLink="/login" routerLinkActive="active"
                           [queryParams]="{next: authService.getNextParam()}">
                            Log In
                        </a>
                    </li>

                    <li *ngIf="authService.isLoggedIn()"
                        class="user-loggedin primary-color-bg-hover"
                        (click)="isAccountDropdownShown()">

                        <a class="dropdown-toggle apply-bg-hover">
                            <img class="avatar" [src]="getProfilePhoto()"/>
                        </a>
                        <ul class="user-dropdown-menu" [class.show-dropdown]="showAccountDropdown">
                            <li *ngIf="authService.isUserAdmin() && siteSettings?.adminUrl">
                                <a [href]="siteSettings?.adminUrl"
                                   class="user-links primary-color-text-hover apply-text-hover">Admin</a>
                            </li>
                            <li *ngIf="authService.isLoggedIn() && !isFloProMember()">
                                <a class="user-links primary-color-text-hover apply-text-hover"
                                   [href]="sportConfigHeader.signUpUrl">Upgrade To Pro</a>
                            </li>
                            <li>
                                <a class="user-links primary-color-text-hover apply-text-hover"
                                   [href]="sportConfigHeader.accountUrl">Account</a>
                            </li>
                            <li>
                                <a class="user-links primary-color-text-hover apply-text-hover" (click)="logout()">Logout</a>
                            </li>
                        </ul>
                    </li>

                    <li *ngIf="!authService.isLoggedIn()" class="join primary-color-bg-hover">
                        <a class="apply-bg-hover primary-color-border" [routerLink]="['/login', 'create-user']"
                           [queryParams]="{next: authService.getNextParam()}"
                           routerLinkActive="active">
                            Join Now
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="mobile-top-bar">
            <a [href]="siteSettings?.coreSiteUrl">
                <img class="logo" routerLink routerLinkActive="active" *ngIf="siteSettings?.site?.name"
                     [attr.title]="siteSettings.site.name" [alt]="siteSettings.site.name"
                     src="../../assets/images/FloArena-Alt.svg">
            </a>
            <div class="nav-icon">
                <a class="search-button" [href]="sportConfigHeader?.searchUrl">
                    <span class="fas fa-search"></span>
                </a>
            </div>
        </div>
    </div>
</header>

<header *ngIf="showHeader" class="secondary-header">
    <div class="mobile-nav-bar primary-color-bg" [class.nav-up]="didScroll">
        <nav>
            <ul class="nav-items-{{ customNav.length }}">
                <li *ngFor="let nav of customNav; let i = index">
                    <a *ngIf="i <= 3"
                       [href]="nav.link"
                       routerLinkActive="active">{{ nav.name }}</a>
                </li>

                <div class="dropdown nav-icon" [class.rotate-down]="showDropdown" (click)="isDropdownShown()">
                    <a class="dropdown-toggle">
                        <span class="fas fa-angle-down"></span>
                    </a>
                </div>
            </ul>
        </nav>
    </div>

    <div class="mobile-menu" [hidden]="!showDropdown" [@isVisibleChanged]="showDropdown">
        <ul class="header-links">
            <li *ngFor="let nav of mobileSubNav; let i = index">
                <a [href]="nav.link" routerLinkActive="active">
                    {{ nav.name }}</a>
            </li>
            <li *ngFor="let nav of mobileAccountSettingsNav; let i = index" class="mobile-account-settings">
                <a [href]="nav.link" routerLinkActive="active">{{nav.name }}</a>
            </li>
            <li *ngIf='authService.isLoggedIn()' class="account-settings">
                <a class="primary-color-text" [href]="sportConfigHeader.accountUrl">Account Settings</a>
            </li>
        </ul>

        <div class="cta">
            <button *ngIf="authService.isLoggedIn()" (click)="logout()" class="btn btn-secondary">
                Log Out
            </button>

            <button *ngIf="authService.isLoggedIn() && !isFloProMember()" class="btn btn-primary"
                    (click)="onUpgradeToPro()">
                Upgrade To Pro
            </button>

            <button *ngIf="!authService.isLoggedIn()" class="btn btn-secondary" (click)="isDropdownShown()"
                    [queryParams]="{next: authService.getNextParam()}" routerLink="/login">
                Log In
            </button>

            <button *ngIf="!authService.isLoggedIn()" class="btn btn-primary" (click)="isDropdownShown()"
                    [queryParams]="{next: authService.getNextParam()}" [routerLink]="['/login', 'create-user']">
                Join Now
            </button>
        </div>
    </div>
</header>
